import type { GridId, ScreenLayout } from "@observe-tech/utils";
import { createGridUtils } from "./grid-utils";
import { createValidationMethods } from "./validation";

const { validateLayout } = createValidationMethods({
  get: (key) => {
    if (key !== "machinesLoaded")
      throw new Error(`reference pruning touched state key ${key}`);
    return {} as never;
  },
  set: () => {
    throw new Error("read-only snapshot");
  },
});
const { gridToUse } = createGridUtils();

export type LayoutReferencePolicy = {
  keepMachine: (id: number) => boolean;
  keepSite: (id: number) => boolean;
  dropped?: (path: string, kind: "machine" | "site", id: number) => void;
};

export const pruneLayoutReferences = (
  layout: ScreenLayout,
  policy: LayoutReferencePolicy,
): ScreenLayout => {
  for (const grid of ["cameraGrid", "cageGrid"] as const) {
    for (const [gridId, cell] of Object.entries(
      layout.screenData[grid] ?? {},
    )) {
      if (!cell) continue;
      const path = `${grid}[${gridId}]`;
      if (!policy.keepMachine(cell.machineId)) {
        layout.screenData[grid][gridId as GridId] = null;
        policy.dropped?.(path, "machine", cell.machineId);
      } else if (cell.pin && !policy.keepMachine(cell.pin.machineId)) {
        policy.dropped?.(`${path}.pin`, "machine", cell.pin.machineId);
        delete cell.pin;
      }
    }
  }
  if (layout.feedScreenData?.sites) {
    layout.feedScreenData.sites.siteIds =
      layout.feedScreenData.sites.siteIds.filter((id) => {
        if (policy.keepSite(id)) return true;
        policy.dropped?.("feedSites", "site", id);
        return false;
      });
  }
  return validateLayout(layout, gridToUse(layout));
};
